import { //firebaseAuth, 
         NODE_API_SERVER } from '../util/constants';
import { INFO, CONSTS } from '../util/object';
import firebase from 'firebase/app';
import decode from 'jwt-decode';
import { encrypt,
         decrypt } from '../util/crypto';
import { makeKosmosJwtToken } from '../util/encode';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { makeUserKey, } from '../util/database';

//import firebase from 'firebase';
//import 'firebase/auth';
//import { jwt } from 'jsonwebtoken';
//const jwt = require('jsonwebtoken');
//const crypto = require('crypto');
//import { appContext } from "./index";
//const CBC_BLOCK_SIZE = 16
//const PDKDF2_SALT = "axos world domination";

class AuthClass {
    State = null;
    setState = null;

    // Initializing important variables
    login = (username, password) => {
        // Get a token from api server using the fetch api
        return this.fetch(`/log-in`, {
            method: 'POST',
            body: JSON.stringify({
                username,
                password
            })
        }).then(res => {
            console.log("login.31: set token=", res.token)
            this.setToken(res.token) // Setting the token in localStorage
            return Promise.resolve(res);
        })
    }


    loggedIn = () => {
        //var loggedin = ((window.user === null) || (window.user === undefined)) ? false : true;
        var loggedin = this.getAuthed();    // get from cookie
        return loggedin;

        // BELOW DOES NOT REALLY WORK, NEED DEBUG
        // Checks if there is a saved token and it's still valid
        const token = this.getToken() // Getting token from localstorage
        if(token !== false) {
            console.log("loggedIn: +++++++++++ token=", token, " expired="+this.isTokenExpired(token));
            return !!token && !this.isTokenExpired(token) // handwaiving here
        } else {
            return false;
        }

    }


    // LOCAL STORAGE MANAGEMENT
    //
    isTokenExpired = (token) => {
        try {
            const decoded = decode(token);
            if (decoded.exp < Date.now() / 1000) { // Checking if token is expired.
                return true;
            }
            else
                return false;
        }
        catch (err) {
            console.log("expired check failed! Line 42: AuthService.js err=", err);
            return true;    // err means expired
        }
    }

    //
    // Get new toekn from backend
    //
    getNewIdToken = (forceRefresh) => {
        firebase.auth()
        .currentUser
        .getIdToken(forceRefresh)
        .then(function(idToken) {
            // Send token to your backend via HTTPS
            // ...
        }).catch(function(error) {
            // Handle error
        });
    }


    // store temp UID user avatar, must have an invite
    setTempUID = (idTempUID, invite) => {
        localStorage.setItem(CONSTS.COOKIE_TEMP_UID, idTempUID);
        localStorage.setItem(CONSTS.COOKIE_INVITE, invite);
        console.log("setTempUID.151:        ", idTempUID, "  invite=",invite);
    }
    // store temp UID user avatar
    getTempUID = (invite) => {
        var temp_uid;
        var cookie = localStorage.getItem(CONSTS.COOKIE_TEMP_UID);
        var oinvite = localStorage.getItem(CONSTS.COOKIE_INVITE);

        // if no invite passed in, then it's a repeat anon login (not invite)
        //
        if ((invite == oinvite) || (invite === null)) {
            temp_uid =  (cookie == null) ? false : cookie;
        } else {
            temp_uid = false;   // invite does not match
        }

        console.log("getTempUID.161:       invite=", invite, "  temp_uid=",temp_uid);
        return temp_uid;
    }

    // store auth state
    //    - custom special return
    setAuthed = (idAuthed) => {
        localStorage.setItem(CONSTS.COOKIE_AUTHED, idAuthed);
        console.log("setAuthed: ", idAuthed);
    }
    getAuthed = () => {
        var cookie = localStorage.getItem(CONSTS.COOKIE_AUTHED);
        var authed =  (cookie === true) ? true : false;      // do not return string "true"!
        return authed;
    }


    // UTIL: Saves cookie to localStorage (replace all others above)
    //
    setCookie = (id, value) => {
        localStorage.setItem(id, value);
        console.log("        SET COOKIE: ",id,"  ", value);
    }
    // retrieve cookie value
    getCookie = (id) => {
        var cookie = localStorage.getItem(id);
        var value =  (cookie == null) ? false : cookie;
        value =  (cookie == "true") ? true : value;
        return value;
    }



    ///////////////////////////////// REPLACE BELOW WITH SETCOOKIE() ////////////////////////////////////
    //
    /*
    setToken = (idToken) => {
        // Saves user token to localStorage
        localStorage.setItem('id_token', idToken);
        //console.log("setToken.73: ",idToken);
    }
    getToken = () => {
        var cookie = localStorage.getItem('id_token');
        var token =  (cookie == null) ? false : cookie;
        // Retrieves the user token from localStorage
        //console.log("getToken: ", token);
        return token;
    }

    // store last email
    setEmail = (email) => {
        // Saves user email to localStorage
        localStorage.setItem('id_email', email);
        console.log("setEmail: ", email);
    }
    getEmail = () => {
        var cookie = localStorage.getItem('id_email');
        var email =  (cookie == null) ? false : cookie;
        return email;
    }

    // store google_id user cred
    setUser = (idUser) => {
        // Saves user token to localStorage
        localStorage.setItem('id_user', idUser);
        console.log("setUser: ", idUser);
    }
    // retrieve google_id user cred
    getUser = () => {
        var cookie = localStorage.getItem('id_user');
        var user =  (cookie == null) ? false : cookie;
        return user;
    }

    // store firebase_uid
    setUid = (idUid) => {
        // Saves user token to localStorage
        localStorage.setItem('id_uid', idUid);
        console.log("setUid: ", idUid);
    }
    // get google_id user avatar
    getUid = () => {
        var cookie = localStorage.getItem('id_uid');
        var uid =  (cookie == null) ? null : cookie;
        return uid;
    }

    // store splash background key
    setSplash = (idSplash) => {
        localStorage.setItem('id_splash', idSplash);
        console.log("setSplash: ", idSplash);
    }
    // store splash background key
    getSplash = () => {
        var cookie = localStorage.getItem('id_splash');
        var splash =  (cookie == null) ? null : cookie;
        return splash;
    }

    // store splash background key
    setLoginCount = (idLoginCount) => {
        localStorage.setItem('id_login_count', parseInt(idLoginCount));
        console.log("setLoginCount: ", idLoginCount);
    }
    // store splash background key
    getLoginCount = () => {
        var cookie = localStorage.getItem('id_login_count');
        var login_count =  (cookie == null) ? 0 : parseInt(cookie);
        return login_count;
    }

    // store google_id user avatar
    setAvatar = (idAvatar) => {
        // Saves user token to localStorage
        localStorage.setItem('id_avatar', idAvatar);
        console.log("setAvatar: ", idAvatar);
    }
    // get google_id user avatar
    getAvatar = () => {
        var cookie = localStorage.getItem('id_avatar');
        var avatar =  (cookie == null) ? false : cookie;
        return avatar;
    }

    // NOT USED AT ALL!
    // store temp UID user avatar
    setInvite = (idTempUID) => {
        localStorage.setItem('id_temp_uid', idTempUID);
        console.log("setTempUID: ", idTempUID);
    }
    // store temp UID user avatar
    getInvite = () => {
        var cookie = localStorage.getItem('id_temp_uid');
        var temp_uid =  (cookie == null) ? false : cookie;
        return temp_uid;
    }

    // Saves user token to localStorage
    setUID = (uid) => {
        localStorage.setItem('uid', uid);
        console.log("setUID: ", uid);
    }
    // retrieve firebase UID cred
    getUID = () => {
        var cookie = localStorage.getItem('uid');
        var uid =  (cookie == null) ? false : cookie;
        return uid;
    }
    */
    //
    ///////////////////////////////// REPLACE ABOVE WITH SETCOOKIE() ////////////////////////////////////


    logout = (next_path, State, setState) => {
        console.log("-------------------------------auth.logout: clean up user state" +
                    "------------------------------------------: next_path="+next_path);

        window.user = null;
        setState('authed', false); 
        setState('has_login', false);
        setState('auth_token', null); 
        setState('uid', null); 
        setState('email', null); 
        setState('first_name', null); 
        setState('last_name', null); 
        setState('auth_src', null); 
        setState('photo', null); 
        setState('account_email', null); 
        //setState('step', CONST.STP_LOGIN);  // go back to login page
        //setState('show_login', true); 
        //setState('target_path', next_path);     // where to go after login
        //setState('entry_path', next_path);     // where to go after login
        //setState('registration', false);
        //setState('has_login', localStorage.getItem('has_login'));
        //setState('show_redirect', true); 

        this.firebase_logout();
    }

    getConfirm = () => {
        // Using jwt-decode npm package to decode the token
        let answer = decode(this.getToken());
        console.log("Recieved answer!");
        return answer;
    }

    fetch = (url, options) => {
        // performs api calls sending the required authentication headers
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
        // Setting Authorization header
        // Authorization: Bearer xxxxxxx.xxxxxxxx.xxxxxx
        if (this.loggedIn()) {
            headers['Authorization'] = 'Bearer ' + this.getToken()
        }

        return fetch(url, {
            headers,
            ...options
        })
            .then(this._checkStatus)
            .then(response => response.json())
    }

    _checkStatus = (response) => {
        // raises an error in case response status is not a success
        if (response.status >= 200 && response.status < 300) { // Success status lies between 200 to 300
            return response
        } else {
            //var error = new Error(response.statusText)
            //error.response = response
            throw response
        }
    }
    
    check_user_token = (token) => {
        return this.fetch(NODE_API_SERVER+"/user/verify", {
            method: 'POST',
            body: JSON.stringify({
                "token": token
            })
        }).then(res => {
            this.setToken(res.token) // Setting the token in localStorage
            return Promise.resolve(res);
        })
    }



    // check if the token in the cookie is still good, to avoid login
    //
    valid_login = () => {
        var token = this.getToken();    // get from local storage

        var res = this.check_user_token(token)
        .then((res) => {
            if(res == true) {
                return true;
            } else {
                return false;
            }
        })

        return res;

        /*
        firebase.auth().currentUser.getIdToken(/* forceRefresh * / true)
        .then(function(idToken) {
            // Send token to your backend via HTTPS
            // ...
        }).catch(function(error) {
            // Handle error
        });
        */
    };




    // based on working login_facebook()
    //
    // src: https://github.com/firebase/quickstart-js/blob/master/auth/google-redirect.html
    //
    login_google = (props) => {
        var currentUser = firebase.auth().currentUser;
        var settings = firebase.auth().settings;
        var res = null;
        console.log("google.273:    LOGIN START  fb.user=", currentUser, " fb.settings=",settings, "  cookies=",document.cookie);

        // src: https://github.com/firebase/quickstart-js/blob/4772fb5ba986951a231f8ca5145eae08f27698bf/auth/google-redirect.html
        if ((currentUser === null) || (currentUser === undefined)) {
            var provider = new firebase.auth.GoogleAuthProvider();
            provider.addScope('email');
        
            console.log("Google.282  ***** Google B4 AUTH....");
            res = firebase.auth()
                //.setPersistence(firebase.auth.Auth.Persistence.LOCAL)
                .signInWithRedirect(provider)       // google

                /* BELOW NOT EXCUTED
                .then((result) => {
                    // will it ever return here?
                    var google_token = result.credential.accessToken;
                    this.setToken(google_token) // Setting the token in localStorage
                    console.log("Google.289  ***** Google Token=",google_token, "  LOGIN SUCCESS  result=",result);
                    return result.user;
            
                }).catch(function(error) {
                    console.log("Google.293  ***** Google FAIL=", error);
                    if (error.code === 'auth/account-exists-with-different-credential') {
                        console.log('You have already signed up with a different auth provider for that email.');
                    } else {
                        console.error(error);
                    }
                    //throw(error);
                    return(error.message);
                });
                */


            window.dispatchEvent(INFO.get_redirect_event);   // check for redirect
            window.dispatchEvent(INFO.check_login_event);    // ..and wakeup auth state change checker



        } else {
            console.log("Google.305  ***** Google ALREADY LOGIN  ", currentUser);
            //firebase.auth().signOut();        // why?
            res = currentUser;
        }

        console.log("google.310:    GOOGLE EXIT  res=",res);
        return res;
    }



    /*
     * using google social sign-in
     * src: https://github.com/firebase/quickstart-js/blob/master/auth/google-popup.html
     */
    old_login_google = (props) => {
        var signin = null;
        var currentUser = firebase.auth().currentUser;
        //provider.addScope('https://www.googleapis.com/auth/contacts.readonly');
        console.log("============== START login_google user: ", currentUser)
    
        // src: https://github.com/firebase/quickstart-js/blob/4772fb5ba986951a231f8ca5145eae08f27698bf/auth/google-popup.html
        if ((currentUser === null) || (currentUser === undefined)) {
            var provider = new firebase.auth.GoogleAuthProvider();
            provider.addScope('email');

            console.log("277:    .......GOOLGE LOGIN provider=", provider);
            signin = firebase.auth()
            .signInWithRedirect(provider)       // OLD google
            .then(function(result) {
                var token = result.credential.accessToken; // google Access Token to access the Google API.
                var user = result.user;  // The signed-in user info.
                //document.getElementById('quickstart-oauthtoken').textContent = token;
                console.log("============== GOOLGE LOGIN SUCCESS  user=", user, "  token=",token, " result=",result);
                return result;
            }).catch(function(error) {
                var errorCode = error.code; // Handle Errors here.
                var errorMessage = error.message; // The email of the user's account used.
                var email = error.email; // The firebase.auth.AuthCredential type that was used.
                var credential = error.credential;
                if (errorCode === 'auth/account-exists-with-different-credential') {
                    console.log('ERROR: You have already signed up with a different auth provider for that email.');
                    // If you are using multiple auth providers on your app you should handle linking
                    // the user's accounts here.
                } else {
                    console.error(error);
                }
            });
        } else {
            firebase.auth().signOut();        // why?
        }

        /* PREV SORT-OF-WORKING LOGIN
        var signin = firebase.auth()
        .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
        .then((result) =>  {
            var provider = new firebase.auth.GoogleAuthProvider();
            provider.addScope('email');

            //return firebase.auth().signInWithPopup(provider);
            return firebase.auth().signInWithRedirect(provider);
        }).catch(function(error)  {
            console.error("goog_auth.250: get signin ERROR ",error);
            return null;
        });
        */

        console.log("317:    .......GOOLGE LOGIN signin=", signin);
        if (signin == null) {
            return null;
        }

        var res = signin.then((result) => {
            console.log("324:    .......GOOLGE LOGIN result=", result);
            var out=null;
            if ((result !== undefined) && (result !== null)) {
                console.log("**** Google Token: SUCCESS SETUP DATA   result=",result.user);
                //var token = result.credential.accessToken;  // Google Access Token, use it to access the Google API.
                //this.setToken(JSON.stringify(token)); // Setting the token in localStorage
                firebase.auth().currentUser.getIdToken(true)
                .then((token) => {
                    this.setToken(JSON.stringify(token)); // Setting the token in localStorage
                    console.log("GOOGLE LOGIN SUCCESS Redirect to ", token);
                })
                //this.setUser(result.user) // Setting the token in localStorage
                //this.setUID(result.user.uid) // Setting the token in localStorage
                //this.setEmail(result.user.email) // Setting the token in localStorage
                //this.setAvatar(result.user.photoURL) // Setting the token in localStorage
                this.setCookie(CONSTS.COOKIE_USER, result.user);        // FOR DEBUG ONLY
                this.setCookie(CONSTS.COOKIE_FB_UID, result.user.uid);
                this.setCookie(CONSTS.COOKIE_EMAIL, result.user.email);
                this.setCookie(CONSTS.COOKIE_AVATAR, result.user.photoURL);
                INFO.email = result.user.email;
                INFO.avatar = result.user.photoURL;

                INFO.anon_uid = CONSTS.DEMO_UID;
                INFO.anon_email =  CONSTS.DEMO_EMAIL;
                INFO.anon_avatar = CONSTS.DEMO_AVATAR;
                INFO.anon_name = CONSTS.DEMO_NAME;

                window.user = result.user;     // not logged in if user==undefined
                out = result.user;
            }
            return out;
        })
        .catch(function(error) {
            if (error.code === 'auth/account-exists-with-different-credential') {
                console.log('You have already signed up with a different auth provider for that email.');
            } else {
                console.error("goog_auth.275: ERROR ",error);
            }
            //throw(error);
            //return(error.message);
            return(null);
        });
        return res;
    }


    login_facebook = (props) => {
        var provider = new firebase.auth.FacebookAuthProvider();
        provider.addScope('email');
        console.log("login_facebook props: ", props)
    
        var res = firebase.auth()
        //.setPersistence(firebase.auth.Auth.Persistence.LOCAL)
        .signInWithRedirect(provider)       // facebook
        .then(function(result) {
            var token = result.credential.accessToken;
            this.setToken(token) // Setting the token in localStorage
            console.log("**** FB Token: "+token);
            //document.getElementById('quickstart-oauthtoken').textContent = token;
            console.log("FB LOGIN SUCCESS: Redirect to ", props);
            return result.user;
    
        }).catch(function(error) {
            if (error.code === 'auth/account-exists-with-different-credential') {
                console.log('You have already signed up with a different auth provider for that email.');
            } else {
                console.error(error);
            }
            throw(error);
            return(error.message);
        });
        return res;
    }

    
    //https://developer.yahoo.com/social/socialdir/
    login_yahoo = (props) => {
        var provider = new firebase.auth.OAuthProvider('yahoo.com');
        //provider.addScope('email');
        //provider.addScope('mail-r');
        console.log("login_yahoo props: ", props)
    
        var res=firebase.auth()
        .signInWithPopup(provider)
        //.setPersistence(firebase.auth.Auth.Persistence.SESSION)
        .then(function(result) {
            var token = result.credential.accessToken;
            this.setToken(token) // Setting the token in localStorage
            console.log("**** Y! Token: "+token);
            //document.getElementById('quickstart-oauthtoken').textContent = token;
            console.log("Y! LOGIN SUCCESS: Redirect to ", props);
            return result.user;
    
        }).catch(function(error) {
            if (error.code === 'auth/account-exists-with-different-credential') {
                console.log('You have already signed up with a different auth provider for that email.');
            } else {
                console.error(error);
            }
            throw(error);
            return(error.message);
        });
        return res;
    }
    
    
    /*
     * REGISTER using user + password sign-in
     * src: https://firebase.google.com/docs/auth/web/manage-users#update_a_users_profile
     */
    firebase_auth = (email, pw) => {
        /*
         * check if the current chk method match db, then verify passwd
         */
        var res=firebase.auth()
        .fetchSignInMethodsForEmail(email)
        //.setPersistence(firebase.auth.Auth.Persistence.SESSION)
        .then(function(signInMethods) {
            if((signInMethods.length > 0) && (signInMethods[0] !== "password")) {
                console.log("*** firebase_auth.210: ", signInMethods);
                throw new Error("Email already used by "+signInMethods[0].replace(".com","")+" Sign in");
            } else {
                console.log("*** firebase_auth: email=", email, "  pw=", pw);
                //var res = firebaseAuth()
                var res = firebase.auth()
                .createUserWithEmailAndPassword(email, pw)
                .then((user) => {
                    var user = firebase.auth().currentUser;
                    console.log("*** firebase_auth: user=", user);
                    /*
                    this.firebase_saveuser(user) {
                    .catch((error) => 
                        throw(error);
                    })
                    */
                    return user;
                })
                .catch((error) => {
                    console.log("createUserWithEmailAndPassword: Error=", error)
                    throw(error);
                })
                return res;
            }
        });

        return res;
    }
    
    
    // 
    update_user = (name, photoUrl) => {
        var user = firebase.auth().currentUser; 
        user.updateProfile({
            displayName: name,
            photoURL: photoUrl,
        }).then(function() {
            // Update successful.
            console.log("update.516:  UPDATE SUCCESSFUL!")
        }).catch(function(error) {
            // An error happened.
            console.log("update.519:  UPDATE FAILED!  ", error)
        });
    }




   /* * LOGIN: using user + password */
    login_email = (email, pw) => {
        var err;
        console.log("login_email: email: "+email+" "+pw)

        /*
         * check if the current chk method match db, then verify passwd
         */
        var res=firebase.auth()
        .fetchSignInMethodsForEmail(email)
        //.setPersistence(firebase.auth.Auth.Persistence.SESSION)
        .then(function(signInMethods) {
            if((signInMethods.length > 0) && (signInMethods[0] !== "password")) {
                console.log("*** login_email.230: ", signInMethods);
                throw new Error("Use "+signInMethods[0].replace(".com", "")+" button above to sign in");
            } else {
                var res = firebase.auth()
                .signInWithEmailAndPassword(email, pw)
                //.setPersistence(firebase.auth.Auth.Persistence.SESSION)
                .then(function(result) {
                    console.log("EMAIL LOGIN SUCCESS: result=", result);
                    if ((result.credential !== null) && (result.credential !== undefined)) {
                        var token = result.credential.accessToken;
                        this.setToken(token) // Setting the token in localStorage
                    }
                    //console.log("**** Email Token: "+token);
                    //console.log("EMAIL LOGIN SUCCESS: Redirect to ", props);
                    return result.user;
                })
                .catch((error) => {
                    console.log("login_email.ERROR.245: ", error);
                    //console.log("EMAIL LOGIN.FAIL : ",email, " error=", error);
                    throw error;
                })
            }

            //console.log("*** login_email.ERROR.251: ", res);
            return(res);
        })
        .catch(function(error) {
            throw(error);
        });

        /*
        if (res === null) {
            console.log("login_email.ERROR.243: res is null");
            firebase.auth()
            .fetchSignInMethodsForEmail(email)
            .then(function(signInMethods) {
                if(signInMethods.length > 0) {
                    err= new Error("Please sign in with "+signInMethods[0]+" credential");
                } 
                console.log("*** login_email.ERROR: " + err.message);
                return(err);
            })
            .catch(function(error) {
                // Some error occurred, you can inspect the code: error.code
                throw(error);
            });
        }
        */

        console.log("*** login_email.RES.259: ", res);
        return res;
    }


    delete_cookie(name, path, domain) {
            document.cookie = name + "=" +
            ((path) ? ";path="+path:"")+
            ((domain)?";domain="+domain:"") +
            ";expires=Thu, 01 Jan 1970 00:00:01 GMT";

            console.log("cookie.683:  FINAL COOKIE ", document.cookie);
        if (this.get_cookie(name)) {
        }
    }

    get_cookie(name){
        var cookie = document.cookie.split(';').some(c => {
            return c.trim().startsWith(name + '=');
        });
        console.log("cookie.689:  GET COOKIE name=", name, "  cookie=",cookie)
        return cookie;
    }

    // return null if no user
    // ref: https://firebase.google.com/docs/reference/js/firebase.auth.Auth#signInWithCredential
    firebase_authed = () => {
        return firebase.auth().currentUser;
        //return firebaseAuth().getUser();
    }

    firebase_logout = () => {
      localStorage.removeItem('id_token');
      localStorage.removeItem('id_user');
      localStorage.removeItem('id_avatar');
      localStorage.removeItem('id_uid');
      localStorage.removeItem('id_login_count');
      localStorage.removeItem('id_splash');
      localStorage.removeItem('id_temp_uid');
      localStorage.removeItem('id_invite');
      localStorage.removeItem('access_token');
      localStorage.removeItem('id_has_login');
      auth.setAuthed(false);     // logged out

      this.delete_cookie("SID", "/", "google.com")

      // NOT WORK KLUDGE: Due to Opera & Android bug, need to delete firebase.auth cookie to force logout
      // api: https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie#syntax
      //document.cookie = 'SID' +'=; domain=.google.com; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';

      //firebase.auth().removeAuthStateListener();  // not working yet
      firebase.auth().signOut()
      .then(() =>{
          var user = firebase.auth().currentUser;
          console.log("552.SUCCESS: LOGOUT COMPLETED  fb.user=", user, "  cookies=",document.cookie);
      })
      .catch((err) =>{
          console.log("555.ERROR: LOGOUT FAILED  ",err);
      })
    }
    
    firebase_resetPassword = (email) =>{
      return firebase.auth().sendPasswordResetEmail(email);
    }
    
    //db.collection('users').doc().set(user)   <<< NO
    //db.collection('users').doc().set(Object.assign({}, user))  <<< YES

    /*
    // TODO: do we need this?
    firebase_saveUser = (user) => {
      console.log("firebase_saveUser(): ", user);
      console.log("firebase_saveUser(): user.email", user.email);
      console.log("firebase_saveUser(): user.uid", user.uid);
      return db
        .collection(`users`)
        .add({
          email: user.email,
          uid: user.uid,
          avatar: user.photo,
        })
        .then(docRef => docRef)
        .catch(function(error) {
          console.error('Error adding document: ', error);
        });
    }
    */

    make_auth_token = (email, key) => {
        if(email == null) {
            console.log("make_auth_token: ERROR: Must have valid email!")
            return
        }
        var token = makeKosmosJwtToken(email, key);
        return token;
    }


    make_invite_token = (payload) => {
        if(payload == null) {
            console.log("make_auth_token: ERROR: Must have valid payload!")
            return
        }

        var bkey = "25da4162f75a78073f7706285f7fca66";
        const iv = "45a277fa0afecf8e";
        var biv = Buffer.from(iv);
        var bpayload = JSON.stringify(payload)
        var epayload = encrypt(bpayload, bkey, biv);

        if (true) {
            var npayload = decrypt({'iv': biv.toString('hex'), 'data': epayload.toString('utf8')}, bkey)
            console.log("KMOS.2 decrypted payload=", npayload);
        }

        console.log("KMOS.2 epayload: ", epayload);
        return epayload;
    }

    decode_invite_token = (token) => {
        if(token == null) {
            console.log("decode_auth_token: ERROR: Must have valid token!")
            return
        }

        var bkey = "25da4162f75a78073f7706285f7fca66";
        const iv = "45a277fa0afecf8e";
        var biv = Buffer.from(iv);

        //var bpayload = JSON.stringify(payload)
        //var epayload = encrypt(bpayload, bkey, biv);
        var npayload = decrypt({'iv': biv.toString('hex'), 'data': token.toString('utf8')}, bkey)
        const out_obj = JSON.parse(npayload)
        console.log("KMOS.2 decrypted token=", out_obj);

        return out_obj;
    }



    /*
     * fill ep user fields with stored social sign-in data
     */
    restoreUserState = (user_obj, State, setState) => {
        if(user_obj !== null) {
 
            // if cookie set then it's still  an anon user (must clear cookie for normal login!)
            //     - if first time anon login, do not
            //
            var temp_uid = auth.getTempUID(INFO.invite_key);       // get from cookie
            console.log("restoreUserState.784:            anon_mode=", INFO.anon_mode, " invite_key=",INFO.invite_key, "  temp_uid=",temp_uid,"  user_obj=", user_obj);
            if (temp_uid === false) {
                //if ((INFO.invite_key === null) && (INFO.anon_mode === false)) {
                if (INFO.invite_key === null) {
                    // regular or repeat login
                    //
                    INFO.uid = user_obj.uid;
                    INFO.anon_uid = CONSTS.DEMO_UID;
                    INFO.login_uid = user_obj.uid;
                    console.log("restoreUserState.790:         NORMAL RESTORE    anon_mode=", INFO.anon_mode, " invite_key=",INFO.invite_key, " uid=",INFO.uid);
                } else {
                    // has invite_key first time thru, if no login user then hijack
                    //
                    if(INFO.anon_mode === true) {
                        INFO.uid = INFO.temp_uid;        // from last time, need to delete cookie once we have real cred login
                        INFO.anon_uid = INFO.anon_uid;
                        INFO.login_uid = user_obj.uid;
                        console.log("restoreUserState.793:         HIJACK FIRST TIME!    anon_mode=", INFO.anon_mode, " invite_key=",INFO.invite_key, " temp_uid=", INFO.temp_uid);
                    } else {
                        // use existing login
                        INFO.uid = user_obj.uid;
                        INFO.anon_uid = null;
                        INFO.login_uid = user_obj.uid;
                        console.log("restoreUserState.863:         INVITE EXISTING USER  invite_key=",INFO.invite_key, " uid=",INFO.uid);
                    }
                }
            } else {
                INFO.uid = temp_uid;        // from last time, need to delete cookie once we have real cred login
                INFO.anon_uid = temp_uid;
                INFO.login_uid = user_obj.uid;
                //INFO.login_uid = temp_uid;
            }

            //auth.setUid(INFO.uid);    // remember current firebase_uid (not the anon UID)
            auth.setCookie(CONSTS.COOKIE_FB_UID, INFO.uid);  // remember current firebase_uid (not the anon UID)
            INFO.email = user_obj.email;
            INFO.user_id = makeUserKey(user_obj.email);
            INFO.avatar = user_obj.photo;

            INFO.current_user = {};
            INFO.current_user.email =  INFO.email;       //for running auto chain drills
            INFO.current_user.avatar =  INFO.avatar;
            INFO.current_user.uid =  INFO.uid;
            INFO.current_user.name =  user_obj.first_name + " " + user_obj.last_name;

            INFO.anon_email =  CONSTS.DEMO_EMAIL;
            INFO.anon_avatar = CONSTS.DEMO_AVATAR;
            INFO.anon_name = CONSTS.DEMO_NAME;

            setState('role', user_obj.role);
            setState('uid', user_obj.uid);
            setState('first_name', user_obj.first_name);
            setState('last_name', user_obj.last_name);
            setState('auth_src', user_obj.auth_src);
            setState('photo', user_obj.photo);
            setState('email', user_obj.email);
            setState('account_email', user_obj.account_email);  // for reading ep 
            //setState('phone_number', user_obj.phone_number);
            //setState('auth_src', user_obj.auth_src);  // for reading ep 

            console.log("restoreUserState.822:            SET UID COOKIE to ",INFO.uid, " user=",user_obj, " current_user=",INFO.current_user);
        }
    }


    // for firebase_auth login (not for invite)
    //
    postInvite = (user, setState) => {
        var curr = firebase.auth().currentUser;
        console.log("post_login.280:      POST INVITE current user =", curr);
        //setState("show_progress", false);
        if ((user !== undefined) && (user !== null)) {
            setState("authed", true);
            //setState("user_id", user.email);
            INFO.email =  user.email;
            INFO.login_uid =  user.uid;
            INFO.uid =  user.uid;

            //INFO.anon_email =  CONSTS.DEMO_EMAIL;
            //INFO.anon_uid = CONSTS.DEMO_UID;
            console.log("postInvite.775:  email=",user.email, " fb.uid=", user.uid);
        } else {
            //GATag("Onboarding", "Invite.GoogleSignInClick", "FAILED", 0);		 // (cat, act, lab, val)
        }
    }


    /*
     * anon login to support demo and youtube (both late binding)
     */
    anonLogin = (State, setState) => {
        this.State = State;
        this.setState = setState;

        //auth.login_email("anon@ldoit.com", "for1session!")
        var res0 = this.login_email("anon@ldoit.com", "for1session!")
        .then(res => {
            console.log("anonLogin.246:        ANON LOGIN SUCCESS!   uid=",INFO.uid, " res=", res)
            INFO.anon_mode = true;

            if(INFO.invite_key === null) {
                this.postInvite(res.user, setState);        // only for fb login
            }
            checkAuthResponse(this.State, this.setState, "invite.310");
            return res;
        })
        .catch(error => {
            console.log("anonLogin.ERROR: ", error)
            //setState('loginMessage', error.message);
            //throw(error);
        });
        return res0;
    }
        



}       // end of AuthClass



    var auth = new AuthClass();

    function reset_state(State, setState) {
        //setState('show_login', false);
        setState('authed', false);
        setState('show_welcome', false);
        setState('show_progress', false);
    }


    function isUserEqual(googleUser, firebaseUser) {
    if (firebaseUser) {
        var providerData = firebaseUser.providerData;
        for (var i = 0; i < providerData.length; i++) {
        if (providerData[i].providerId === firebase.auth.GoogleAuthProvider.PROVIDER_ID &&
            providerData[i].uid === googleUser.getBasicProfile().getId()) {
            // We don't need to reauth the Firebase connection.
            return true;
        }
        }
    }
        return false;
    }


    
    // REFACTOR OF checkAuthResponse()
    //      - code was getting too messy
    //
    //  ref: https://firebase.google.com/docs/auth/web/google-signin
    //
    async function onSignin(googleUser, State, setState, from) {

        if ((window.user !== undefined) && (window.user !== null)) {
            console.log("on_signin.883:   EXIT....no window.user");
            //setState('authed', true);
            return;
        }

        console.log("on_signin.929:       LISTENING... from=",from, " show_prog=",INFO.show_login_progress," googleUser=",googleUser,"  user=",window.user," " ,Date.now());
        INFO.show_login_progress = true;
        setState('show_progress', true);

        //* NOTE: This code below runs on callback stack, will not return data!
        var unsubscribe = firebase.auth()
            .onAuthStateChanged( (user) => {
                unsubscribe();
                var firebaseUser = user;

                if (!isUserEqual(googleUser, firebaseUser)) {
                    console.log("on_signin.936:       FIREBASE AUTH SIGNIN START...",      // JSON.stringify(user));
                            user.email, " ", user.displayName, " ",user.uid, " ",user.providerData[0].providerId);
                    window.user = user;     // not logged in if user==undefined
                    //auth.setToken(user.refreshToken);    // NEED THIS? avoid login if token is valid

                    INFO.show_login_progress = true;
                    setState('show_progress', true);
                    console.log("on_signin.943: DETECT "+user.providerData[0].providerId+" LOG IN *********  show_prog=",INFO.show_login_progress);

                    setupUserState(user, State, setState, "on_signin.971");

                    // Sign in with credential from the Google user.
                    var credential = firebase.auth.GoogleAuthProvider.credential(
                    googleUser.getAuthResponse().id_token);
                    firebase.auth().signInWithCredential(credential)
                    .catch((error) => {
                        var errorCode = error.code;
                        var errorMessage = error.message;
                        var email = error.email;    // The email of the user's account used.
                        var credential = error.credential;  // The firebase.auth.AuthCredential type that was used.
                    })
                } else {
                    console.log('on_sigin.957:  User already signed-in Firebase.', user);
                }
            })


        // catch result from the redirect
        firebase.auth().getRedirectResult().then((result) => {
            console.log("signin.930:       RECIVING REDIRECT RESULT: result=", result);
            if (result.credential) {
                var token = result.credential.accessToken;
            }

            var user = result.user;    // The signed-in user info.
            checkAuthResponse.bind(this, State, setState, "redirect.407");  // special binding of param

        }).catch(function(error) {
            var errorCode = error.code;
            var errorMessage = error.message;
            var email = error.email;
            var credential = error.credential;
            if (errorCode === 'auth/account-exists-with-different-credential') {
                alert('You have already signed up with a different auth provider for that email.');
                // If you are using multiple auth providers on your app you should handle linking
                // the user's accounts here.
            } else {
                console.error(error);
            }
        });




    }


    // util
    // set up user state after login
    //
    function setupUserState(user, State, setState, from) {
        if ((user !== undefined) && (user !== null)) {
            console.log("authchg.573:     FIREBASE LOGIN AUTH processing... from=", from,      // JSON.stringify(user));
                    user.email, " ", user.displayName, " ",user.uid, " ",user.providerData[0].providerId);
            window.user = user;     // not logged in if user==undefined
            //auth.setToken(user.refreshToken);    // NEED THIS? avoid login if token is valid

            INFO.show_login_progress = true;
            setState('show_progress', true);
            console.log("setup.976:      DETECT "+user.providerData[0].providerId+" LOG IN *********  show_prog=",INFO.show_login_progress);
            //localStorage.setItem('has_login', true);    // next time display "Login" instead of "Register"
            auth.setAuthed(true);     // logged in
            //auth.setUid(user.uid);    // remember current firebase_uid (OK for regular login)
            auth.setCookie(CONSTS.COOKIE_FB_UID, user.uid);   // remember current firebase_uid (OK for regular login)

            var first_name = (user.displayName == null) ? "" : user.displayName.split(" ")[0];
            var last_name = (user.displayName == null) ? "" : user.displayName.split(" ").pop();
            var email = (user.email == null) ? user.providerData[0].email : user.email;
            var phone_number = (user.providerData[0].phoneNumber == null) ? "" : user.providerData[0].phoneNumber;

            if((email === null) || (email == "")) {
                console.log("setup.985.ERROR: ****** NO EMAIL, LOGOUT ******")
                auth.logout('/', State, setState);   // can't proceed w/o email!
                return;
            }

            if (email == "anon@ldoit.com") {
                console.log("setup.991:       DETECTED ANONYMOUS USER!  ");
                INFO.anon_mode = true;
            }

            // after regular login, remove any anon late binding cookies
            //
            if ((INFO.anon_mode === false) && (INFO.invite_key === null)) {
                console.log("setupUserState.1004:          NOT ANON MODE, REMOVE OLD ANON COOKIE")


                // TODO: DO WE CALL BACKEND AND BIND THE ANON ACCOUNT @HERE?  NEED AN EXTRA FLAG! ******


                localStorage.removeItem('id_temp_uid');
                localStorage.removeItem('id_invite');
            }

            var user_obj = new Object();
            user_obj.uid = user.uid;
            user_obj.first_name= first_name;
            user_obj.last_name= last_name;
            user_obj.phone_number= phone_number;
            user_obj.auth_src= user.providerData[0].providerId;
            user_obj.photo= user.providerData[0].photoURL;
            user_obj.email= email;
            user_obj.account_email= email;
            //console.log("setup.1004: user_archive=", user_obj)

            auth.restoreUserState(user_obj, State, setState);

            /*
            //setState('has_login', localStorage.getItem('has_login'));
            setState('authed', true);               // got user cred
            setState('show_redirect', true);        //
            setState('refresh_display', ++State.refresh_display);
            */
            window.dispatchEvent(INFO.login_event);

            //setState('splash_done', true);        // need to do it after read_ep?
            //setState('target_path', "/console");
            //console.log("******** REDIRECTING TO.166: ", State);
            //props.history.push("/console");
            //props.history.push(State.target_path);
            //history.push("/console");
        } else {
            //console.log("authchg.801: BAD FIREBASE AUTH  user=", JSON.stringify(user));




            /* THIS WAS KINDA WORKING...Replaced by check_login signal
            //
            console.log("setup.1023:        DETECT LOG OUT  from=",from, " user=",user);
            INFO.show_login_progress = false;
            window.dispatchEvent(INFO.logout_event);
            */




            // can not setState here, causes loops
            //
            //setState('show_progress', false);
            //setState('authed', false);
            //setState('target_path', "/form");       // display login page
            //setState('show_redirect', true);

            /*
            //setState('target_path', "/form");       // display login page
            setState('authed', true);               // got user cred
            setState('show_redirect', true);
            setState('refresh_display', ++State.refresh_display);
            setState('splash_done', true);          // only show splash for new users
            */
        }

    }


    // after start login, monitor redirect page output
    //     - this retrieves the oauth token (if needed)
    //
    // per: https://github.com/firebase/firebase-js-sdk/issues/1682
    // IS THIS NEEDED STILL?
    async function getRedirectResult(State, setState, from) {

        // catch login result after redirect
        firebase.auth()
        .getRedirectResult()
        .then((result) => {
            //console.log("get_redirect.1122:       RECIVING LOGIN REDIRECT RESULT: from=", from, " result=", result);
            if (result.user) {
                if (result.credential) {
                    var token = result.credential.accessToken;
                }

                // success route: get here confirmed after redirect
                //
                console.log("get_redirect.1138:            +++++ GOT LOGIN REDIRECT RESULT: from=", from, " result=", result);
                var user = result.user;    // The signed-in user info.
                onSignin.bind(this, State, setState, "redirect.407");  // special binding of param
            } else {
                console.log("get_redirect.1131:            ----- NO LOGIN REDIRECT RESULT: from=", from, " result=", result);
                //window.dispatchEvent(INFO.check_login_event);  // not right place
            }

        }).catch(function(error) {
            var errorCode = error.code;
            var errorMessage = error.message;
            var email = error.email;
            var credential = error.credential;
            if (errorCode === 'auth/account-exists-with-different-credential') {
                alert('You have already signed up with a different auth provider for that email.');
                // If you are using multiple auth providers on your app you should handle linking
                // the user's accounts here.
            } else {
                console.error(error);
            }
        });
    }





    // KEY ROUTINE: Listening for auth state changes, since it's a callback
    // only way to pass info back is via State
    //async function checkAuthResponse(State, setState) {
    async function checkAuthResponse(State, setState, from) {
        //var State = INFO.State;
        //var setState = INFO.setState;

        // IS THIS NEEDED STILL?
        // per: https://github.com/firebase/firebase-js-sdk/issues/1682
        //getRedirectResult(State, setState, from);

        /*
        if ((window.user !== undefined) && (window.user !== null)) {
            console.log("checkAuthResponse.883:   EXIT....no window.user");
            //setState('authed', true);
            return;
        }
        */

        //console.log("checkAuthResponse.1164:  ...LISTENING LOGIN... from=",from, " show_prog=",INFO.show_login_progress,"  user=",window.user," " ,Date.now());
        //INFO.show_login_progress = true;
        //setState('show_progress', true);

        //* NOTE: This code below runs on callback stack, will not return data!
        var unsubscribe = 
                firebase.auth()
                .onAuthStateChanged( (user) => {

                    if (user){
                        console.log("checkAuthResponse.1198:       ++++++ AUTH_CHG: LOGIN GOT AUTH CHG... from=",from, " user=",user,"  ", Date.now());
                        setupUserState(user, State, setState, "chk_auth_resp.1173");
                    } else{
                        console.log("checkAuthResponse.1191:       ------ AUTH_CHG: RE-SIGNAL LOGIN AUTH CHECK... from=",from, " user=",user,"  ") //, Date.now());
                        window.dispatchEvent(INFO.check_login_event);
                    }
                    unsubscribe();

                    // can not return data, this is a callback stub
                    //console.log("checkAuthResponse: RETURNING user_obj=", user_obj);
                    //return user_obj;
                })

        /*
        const user = await result;
        //document.getElementById('quickstart-sign-in').addEventListener('click', toggleSignIn, false);
        console.log("checkAuthResponse: result= ", user)
        return user;
        */
    }

export { getRedirectResult, onSignin, checkAuthResponse, AuthClass }